import React from 'react'

import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom";

import CardListButton from '../../../utils/components/CardListButton/CardListButton'
import TitleSVG from       '../../../utils/components/TitleSVG/TitleSVG';

import style from './InventoryOptions.module.css'

import SaleMadeImg from     '../../../assets/img/sale_made.png';
import PurchaseMadeImg from '../../../assets/img/purchase_made.png';
import SaleRegisterImg from '../../../assets/img/sale_register.png';
import { Product } from     '../../../assets/icons';
import { Inventory } from   '../../../assets/icons';
import { Translate } from   '../../../language';

const InventoryOptions = () => {
    const history = useHistory();  
    const { userInfo } = useSelector(state => state.userInfo)
    return (
        <div className={style.container_all}>
            <TitleSVG Icon= {Inventory} titleHighlight={Translate('inventoryTitleHighlight','es')} title = {Translate('inventoryTitle','es')} />
            <div className={style.buttons_container}>
                <div className={style.row_buttons}>
                    <div className={style.card_list_button}>
                        <CardListButton 
                            Icon={ Product } 
                            text={Translate('inventoryProducts', 'es')} 
                            textButton={Translate('getInto', 'es')}
                            onClick={() => { history.push('/Inventory/Inventory') }}
                            styleImg = {style.card_list_button_product_img} />
                    </div>
                    <div className={style.card_list_button}>
                        <CardListButton picture={PurchaseMadeImg} 
                            text={Translate('inventoryPurchases', 'es')}
                            onClick={() => { history.push('/MarketPlace/Purchases') }}
                            textButton={Translate('getInto', 'es')} />
                    </div>
                    <div className={style.card_list_button}>
                        <CardListButton picture={SaleMadeImg} 
                            text={Translate('inventorySales', 'es')} 
                            onClick={() => { history.push('/Inventory/Sales') }}
                            textButton={Translate('getInto', 'es')} />
                    </div>
                    <div className={style.card_list_button}>
                        <CardListButton picture={SaleRegisterImg} 
                            text={Translate('inventorySaleRegister', 'es')} 
                            textButton={Translate('getInto', 'es')} 
                            onClick={() => { history.push('/Inventory/SaleRegister') }}/>
                    </div>
                    <div className={style.card_list_button}>
                        <CardListButton picture={SaleRegisterImg} 
                            text={Translate('inventorySaleUtility', 'es')} 
                            textButton={Translate('getInto', 'es')} 
                            onClick={() => { history.push('/Inventory/Utility') }}/>
                    </div>
                    <div className={style.card_list_button}>
                        <CardListButton picture={SaleRegisterImg} 
                            text={Translate('inventoryReportByType', 'es')} 
                            textButton={Translate('getInto', 'es')} 
                            onClick={() => { history.push('/Inventory/ReportByType') }}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InventoryOptions